import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import Weather from './Weather';
// import Testminds from './Project/Testminds';
import Ai from './Ai/Ai';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Ai/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
